// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableSortLabel,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   MedicalServices as UsageIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
//   TrendingUp as StatsIcon,
//   Pets as AnimalIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const MedicationUsagePage = () => {
//   const navigate = useNavigate();
//   const [usageRecords, setUsageRecords] = useState([]);
//   const [filteredRecords, setFilteredRecords] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     animal_id: "",
//     medication_id: ""
//   });

//   // Dialogs
//   const [showFilters, setShowFilters] = useState(false);
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [openStatsDialog, setOpenStatsDialog] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState(null);

//   // Form Data
//   const [usageForm, setUsageForm] = useState({
//     medication_id: "",
//     animal_id: "",
//     quantity_used: "",
//     date: new Date().toISOString().split('T')[0],
//     notes: ""
//   });

//   const [animals, setAnimals] = useState([]);
//   const [medications, setMedications] = useState([]);
//   const [usageStats, setUsageStats] = useState(null);

//   const API_URL = "http://127.0.0.1:5055/api/medication-usage";

//   // Table Columns for Virtualized Table
//   const columns = [
//     { width: 150, label: 'Medication', dataKey: 'medication_name' },
//     { width: 120, label: 'Animal ID', dataKey: 'animal_id' },
//     { width: 150, label: 'Animal Name', dataKey: 'animal_name' },
//     { width: 120, label: 'Quantity Used', dataKey: 'quantity_used' },
//     { width: 120, label: 'Usage Date', dataKey: 'date' },
//     { width: 200, label: 'Notes', dataKey: 'notes' },
//     { width: 200, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Fetch Usage Records
//   const fetchUsageRecords = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(API_URL);
//       const data = await res.json();
      
//       if (Array.isArray(data)) {
//         setUsageRecords(data);
//       } else {
//         setUsageRecords([]);
//       }
//     } catch (err) {
//       console.error('Error fetching usage records:', err);
//       swal("Error", "Failed to fetch medication usage records", "error");
//       setUsageRecords([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch Animals and Medications
//   const fetchAnimalsAndMeds = async () => {
//     try {
//       // Fetch animals
//       const animalsRes = await fetch("http://127.0.0.1:5055/api/animals");
//       const animalsData = await animalsRes.json();
//       if (animalsData.animals && Array.isArray(animalsData.animals)) {
//         setAnimals(animalsData.animals);
//       } else if (Array.isArray(animalsData)) {
//         setAnimals(animalsData);
//       }

//       // Fetch medications
//       const medsRes = await fetch("http://127.0.0.1:5055/api/medications");
//       const medsData = await medsRes.json();
//       if (Array.isArray(medsData)) {
//         setMedications(medsData);
//       }
//     } catch (err) {
//       console.error('Error fetching data:', err);
//     }
//   };

//   // Fetch Usage Statistics
//   const fetchUsageStats = async () => {
//     try {
//       const res = await fetch(`${API_URL}/statistics`);
//       const data = await res.json();
//       setUsageStats(data);
//     } catch (err) {
//       console.error('Error fetching usage statistics:', err);
//     }
//   };

//   useEffect(() => {
//     fetchUsageRecords();
//     fetchAnimalsAndMeds();
//     fetchUsageStats();
//   }, []);

//   // Filter records based on search and filters
//   useEffect(() => {
//     if (!Array.isArray(usageRecords)) {
//       setFilteredRecords([]);
//       return;
//     }
    
//     let results = usageRecords;

//     // Apply search term
//     if (searchTerm) {
//       results = results.filter(record =>
//         (record.medication_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (record.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (record.notes?.toLowerCase() || '').includes(searchTerm.toLowerCase())
//       );
//     }

//     // Apply animal filter
//     if (filters.animal_id) {
//       results = results.filter(record => 
//         record.animal_id.toString() === filters.animal_id
//       );
//     }

//     // Apply medication filter
//     if (filters.medication_id) {
//       results = results.filter(record => 
//         record.medication_id.toString() === filters.medication_id
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
        
//         if (aVal === null || aVal === undefined) return 1;
//         if (bVal === null || bVal === undefined) return -1;
        
//         if (sortConfig.key === 'date') {
//           const aDate = new Date(a.date);
//           const bDate = new Date(b.date);
//           return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
//         }
        
//         if (typeof aVal === 'string' && typeof bVal === 'string') {
//           return sortConfig.direction === 'asc' 
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }
        
//         if (aVal < bVal) {
//           return sortConfig.direction === 'asc' ? -1 : 1;
//         }
//         if (aVal > bVal) {
//           return sortConfig.direction === 'asc' ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     setFilteredRecords(results);
//   }, [usageRecords, searchTerm, filters, sortConfig]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       animal_id: "",
//       medication_id: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   };

//   // Form Handlers
//   const handleFormChange = (field, value) => {
//     setUsageForm(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const resetForm = () => {
//     setUsageForm({
//       medication_id: "",
//       animal_id: "",
//       quantity_used: "",
//       date: new Date().toISOString().split('T')[0],
//       notes: ""
//     });
//   };

//   // Get available quantity for selected medication
//   const getAvailableQuantity = () => {
//     const medication = medications.find(med => med.id.toString() === usageForm.medication_id);
//     return medication ? medication.quantity : 0;
//   };

//   // Create Usage Record
//   const handleCreateUsageRecord = async () => {
//     if (!usageForm.medication_id || !usageForm.animal_id || !usageForm.quantity_used) {
//       swal("Error", "Medication, animal, and quantity used are required", "error");
//       return;
//     }

//     if (usageForm.quantity_used <= 0) {
//       swal("Error", "Quantity used must be positive", "error");
//       return;
//     }

//     const availableQty = getAvailableQuantity();
//     if (usageForm.quantity_used > availableQty) {
//       swal("Error", `Insufficient medication quantity. Available: ${availableQty}`, "error");
//       return;
//     }

//     try {
//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...usageForm,
//           quantity_used: parseFloat(usageForm.quantity_used)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Medication usage recorded successfully!", "success");
//         setOpenCreateDialog(false);
//         resetForm();
//         fetchUsageRecords();
//         fetchUsageStats();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Update Usage Record
//   const handleUpdateUsageRecord = async () => {
//     if (!selectedRecord) return;

//     try {
//       const res = await fetch(`${API_URL}/${selectedRecord.id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...usageForm,
//           quantity_used: parseFloat(usageForm.quantity_used)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Usage record updated successfully!", "success");
//         setOpenEditDialog(false);
//         setSelectedRecord(null);
//         resetForm();
//         fetchUsageRecords();
//         fetchUsageStats();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (recordId) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the usage record!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${recordId}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           fetchUsageRecords();
//           fetchUsageStats();
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // View Handler
//   const handleView = (record) => {
//     setSelectedRecord(record);
//     setOpenViewDialog(true);
//   };

//   // Open Edit Dialog
//   const handleEdit = (record) => {
//     setSelectedRecord(record);
//     setUsageForm({
//       medication_id: record.medication_id.toString(),
//       animal_id: record.animal_id.toString(),
//       quantity_used: record.quantity_used.toString(),
//       date: new Date(record.date).toISOString().split('T')[0],
//       notes: record.notes || ""
//     });
//     setOpenEditDialog(true);
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: 'info.main', 
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           <TableSortLabel
//             active={sortConfig.key === column.dataKey}
//             direction={sortConfig.direction}
//             onClick={() => handleSort(column.dataKey)}
//             sx={{ color: 'white !important' }}
//           >
//             {column.label}
//           </TableSortLabel>
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, record) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {record.medication_name}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {record.animal_id}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {record.animal_name}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {record.quantity_used} units
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {new Date(record.date).toLocaleDateString()}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap title={record.notes}>
//           {record.notes ? 
//             (record.notes.length > 30 ? `${record.notes.substring(0, 30)}...` : record.notes) 
//             : 'No notes'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             color="info"
//             onClick={() => handleView(record)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="primary"
//             onClick={() => handleEdit(record)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(record.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'info.dark' }}>
//         <Toolbar>
//           <UsageIcon sx={{ mr: 2 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Medication Usage
//           </Typography>
//           <Button 
//             startIcon={<StatsIcon />}
//             onClick={() => setOpenStatsDialog(true)}
//             variant="outlined"
//             sx={{ color: 'white', borderColor: 'white', mr: 2 }}
//           >
//             Statistics
//           </Button>
//           <Chip 
//             label={`${usageRecords.length} Records`} 
//             color="primary" 
//             variant="filled"
//             sx={{ color: 'white', fontWeight: 'bold', mr: 2 }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={() => setOpenCreateDialog(true)}
//             sx={{ borderRadius: 2, backgroundColor: 'success.main' }}
//           >
//             Record Usage
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: 'info.light' }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search by medication, animal name, or notes..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     color="info"
//                   >
//                     Filters
//                   </Button>
//                   <Button onClick={resetFilters} variant="outlined" size="small" color="info">
//                     Reset
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Animal</InputLabel>
//                       <Select
//                         value={filters.animal_id}
//                         onChange={(e) => handleFilterChange('animal_id', e.target.value)}
//                         label="Animal"
//                       >
//                         <MenuItem value="">All Animals</MenuItem>
//                         {animals.map(animal => (
//                           <MenuItem key={animal.id} value={animal.id.toString()}>
//                             {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Medication</InputLabel>
//                       <Select
//                         value={filters.medication_id}
//                         onChange={(e) => handleFilterChange('medication_id', e.target.value)}
//                         label="Medication"
//                       >
//                         <MenuItem value="">All Medications</MenuItem>
//                         {medications.map(med => (
//                           <MenuItem key={med.id} value={med.id.toString()}>
//                             {med.name} ({med.quantity} available)
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
//             <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }}>
//               <Typography variant="h6" gutterBottom>
//                 Medication Usage Tracking
//               </Typography>
//               Record medication administration to animals, track inventory consumption, and monitor treatment effectiveness.
//             </Alert>
            
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress color="info" />
//               </Box>
//             ) : filteredRecords.length === 0 ? (
//               <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: 'info.light' }}>
//                 <CardContent>
//                   <AnimalIcon sx={{ fontSize: 64, color: 'info.main', mb: 2 }} />
//                   <Typography variant="h5" color="info.main" gutterBottom>
//                     No usage records found
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     Start tracking medication usage by recording administration to animals
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     color="info" 
//                     onClick={() => setOpenCreateDialog(true)} 
//                     size="large"
//                   >
//                     Record First Usage
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: 'info.light', borderRadius: 1 }}>
//                 <TableVirtuoso
//                   data={filteredRecords}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Create Usage Record Dialog */}
//       <Dialog 
//         open={openCreateDialog} 
//         onClose={() => setOpenCreateDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <AddIcon sx={{ mr: 1 }} />
//             Record Medication Usage
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Medication *</InputLabel>
//                 <Select
//                   value={usageForm.medication_id}
//                   onChange={(e) => handleFormChange('medication_id', e.target.value)}
//                   label="Medication *"
//                 >
//                   {medications.map(med => (
//                     <MenuItem key={med.id} value={med.id.toString()}>
//                       {med.name} ({med.quantity} available)
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Animal *</InputLabel>
//                 <Select
//                   value={usageForm.animal_id}
//                   onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                   label="Animal *"
//                 >
//                   {animals.map(animal => (
//                     <MenuItem key={animal.id} value={animal.id.toString()}>
//                       {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Quantity Used *"
//                 type="number"
//                 value={usageForm.quantity_used}
//                 onChange={(e) => handleFormChange('quantity_used', e.target.value)}
//                 inputProps={{ min: 0.1, step: 0.1 }}
//                 helperText={
//                   usageForm.medication_id ? 
//                   `Available: ${getAvailableQuantity()} units` : 
//                   'Select a medication first'
//                 }
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Usage Date"
//                 type="date"
//                 value={usageForm.date}
//                 onChange={(e) => handleFormChange('date', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Notes"
//                 placeholder="Enter administration notes, dosage instructions, or observations..."
//                 value={usageForm.notes}
//                 onChange={(e) => handleFormChange('notes', e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenCreateDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleCreateUsageRecord} 
//             variant="contained" 
//             color="success"
//             disabled={!usageForm.medication_id || !usageForm.animal_id || !usageForm.quantity_used}
//           >
//             Record Usage
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Usage Record Dialog */}
//       <Dialog 
//         open={openEditDialog} 
//         onClose={() => setOpenEditDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <EditIcon sx={{ mr: 1 }} />
//             Edit Usage Record
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Medication *</InputLabel>
//                 <Select
//                   value={usageForm.medication_id}
//                   onChange={(e) => handleFormChange('medication_id', e.target.value)}
//                   label="Medication *"
//                 >
//                   {medications.map(med => (
//                     <MenuItem key={med.id} value={med.id.toString()}>
//                       {med.name} ({med.quantity} available)
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Animal *</InputLabel>
//                 <Select
//                   value={usageForm.animal_id}
//                   onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                   label="Animal *"
//                 >
//                   {animals.map(animal => (
//                     <MenuItem key={animal.id} value={animal.id.toString()}>
//                       {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Quantity Used *"
//                 type="number"
//                 value={usageForm.quantity_used}
//                 onChange={(e) => handleFormChange('quantity_used', e.target.value)}
//                 inputProps={{ min: 0.1, step: 0.1 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Usage Date"
//                 type="date"
//                 value={usageForm.date}
//                 onChange={(e) => handleFormChange('date', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Notes"
//                 value={usageForm.notes}
//                 onChange={(e) => handleFormChange('notes', e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleUpdateUsageRecord} 
//             variant="contained" 
//             color="primary"
//             disabled={!usageForm.medication_id || !usageForm.animal_id || !usageForm.quantity_used}
//           >
//             Update Record
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* View Usage Record Dialog */}
//       <Dialog 
//         open={openViewDialog} 
//         onClose={() => setOpenViewDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <ViewIcon sx={{ mr: 1 }} />
//               Usage Record Details
//             </Box>
//             <IconButton onClick={() => setOpenViewDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedRecord && (
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Medication Information
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Medication:</strong> {selectedRecord.medication_name}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Quantity Used:</strong> {selectedRecord.quantity_used} units
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
              
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Animal Information
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Animal ID:</strong> {selectedRecord.animal_id}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Animal Name:</strong> {selectedRecord.animal_name}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Usage Details
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Date:</strong> {new Date(selectedRecord.date).toLocaleDateString()}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {selectedRecord.notes && (
//                 <Grid item xs={12}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <Typography variant="h6" gutterBottom color="primary">
//                         Administration Notes
//                       </Typography>
//                       <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
//                         {selectedRecord.notes}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               )}
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Statistics Dialog */}
//       <Dialog 
//         open={openStatsDialog} 
//         onClose={() => setOpenStatsDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <StatsIcon sx={{ mr: 1 }} />
//               Medication Usage Statistics
//             </Box>
//             <IconButton onClick={() => setOpenStatsDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {usageStats ? (
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Overview
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Total Records:</strong> {usageStats.total_records}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Total Quantity Used:</strong> {usageStats.total_quantity_used} units
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Medication Breakdown
//                     </Typography>
//                     {Object.entries(usageStats.medication_breakdown).length > 0 ? (
//                       Object.entries(usageStats.medication_breakdown).map(([medName, quantity]) => (
//                         <Box key={medName} sx={{ 
//                           display: 'flex', 
//                           justifyContent: 'space-between', 
//                           alignItems: 'center',
//                           py: 1,
//                           borderBottom: '1px solid',
//                           borderColor: 'divider'
//                         }}>
//                           <Typography variant="body2">{medName}</Typography>
//                           <Chip 
//                             label={`${quantity} units`} 
//                             size="small"
//                             color="primary"
//                           />
//                         </Box>
//                       ))
//                     ) : (
//                       <Typography variant="body2" color="textSecondary">
//                         No usage data available
//                       </Typography>
//                     )}
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {usageStats.period && (usageStats.period.start_date || usageStats.period.end_date) && (
//                 <Grid item xs={12}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <Typography variant="h6" gutterBottom color="primary">
//                         Period
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Start Date:</strong> {usageStats.period.start_date ? 
//                           new Date(usageStats.period.start_date).toLocaleDateString() : 'Not specified'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>End Date:</strong> {usageStats.period.end_date ? 
//                           new Date(usageStats.period.end_date).toLocaleDateString() : 'Not specified'}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               )}
//             </Grid>
//           ) : (
//             <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//               <CircularProgress color="info" />
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenStatsDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Add FAB for mobile */}
//       <Fab
//         color="info"
//         aria-label="add"
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' }
//         }}
//         onClick={() => setOpenCreateDialog(true)}
//       >
//         <AddIcon />
//       </Fab>
//     </Box>
//   );
// };

// export default MedicationUsagePage;




// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableSortLabel,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   MedicalServices as UsageIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
//   TrendingUp as StatsIcon,
//   Pets as AnimalIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const MedicationUsagePage = () => {
//   const navigate = useNavigate();
//   const [usageRecords, setUsageRecords] = useState([]);
//   const [filteredRecords, setFilteredRecords] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     animal_id: "",
//     medication_id: ""
//   });

//   // Dialogs
//   const [showFilters, setShowFilters] = useState(false);
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [openStatsDialog, setOpenStatsDialog] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState(null);

//   // Form Data
//   const [usageForm, setUsageForm] = useState({
//     medication_id: "",
//     animal_id: "",
//     quantity_used: "",
//     date: new Date().toISOString().split('T')[0],
//     notes: ""
//   });

//   const [animals, setAnimals] = useState([]);
//   const [medications, setMedications] = useState([]);
//   const [usageStats, setUsageStats] = useState(null);

//   const API_URL = "https://dairy.server.statify.co.ke/api/medication-usage";

//   // Helper function to format date for form input
//   const formatDateForInput = (dateString) => {
//     if (!dateString) return new Date().toISOString().split('T')[0];
    
//     try {
//       // Try parsing the date string - handle various formats
//       const date = new Date(dateString);
      
//       // Check if date is valid
//       if (isNaN(date.getTime())) {
//         console.warn('Invalid date:', dateString);
//         return new Date().toISOString().split('T')[0];
//       }
      
//       return date.toISOString().split('T')[0];
//     } catch (error) {
//       console.error('Error formatting date:', error, dateString);
//       return new Date().toISOString().split('T')[0];
//     }
//   };

//   // Table Columns for Virtualized Table
//   const columns = [
//     { width: 150, label: 'Medication', dataKey: 'medication_name' },
//     { width: 120, label: 'Animal ID', dataKey: 'animal_id' },
//     { width: 150, label: 'Animal Name', dataKey: 'animal_name' },
//     { width: 120, label: 'Quantity Used', dataKey: 'quantity_used' },
//     { width: 120, label: 'Usage Date', dataKey: 'date' },
//     { width: 200, label: 'Notes', dataKey: 'notes' },
//     { width: 200, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Fetch Usage Records
//   const fetchUsageRecords = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(API_URL);
//       const data = await res.json();
      
//       if (Array.isArray(data)) {
//         // Transform data to include formatted dates
//         const transformedRecords = data.map(record => {
//           // Format date for display
//           let displayDate = "Invalid Date";
//           try {
//             const recordDate = new Date(record.date);
//             if (!isNaN(recordDate.getTime())) {
//               displayDate = recordDate.toLocaleDateString();
//             }
//           } catch (err) {
//             console.error('Error formatting date:', err);
//           }

//           return {
//             ...record,
//             date: displayDate,
//             short_notes: record.notes ? 
//               (record.notes.length > 30 ? `${record.notes.substring(0, 30)}...` : record.notes) 
//               : 'No notes',
//             originalDate: record.date // Keep original date for editing
//           };
//         });
//         setUsageRecords(transformedRecords);
//       } else {
//         setUsageRecords([]);
//       }
//     } catch (err) {
//       console.error('Error fetching usage records:', err);
//       swal("Error", "Failed to fetch medication usage records", "error");
//       setUsageRecords([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch Animals and Medications
//   const fetchAnimalsAndMeds = async () => {
//     try {
//       // Fetch animals
//       const animalsRes = await fetch("https://dairy.server.statify.co.ke/api/animals");
//       const animalsData = await animalsRes.json();
//       if (animalsData.animals && Array.isArray(animalsData.animals)) {
//         setAnimals(animalsData.animals);
//       } else if (Array.isArray(animalsData)) {
//         setAnimals(animalsData);
//       }

//       // Fetch medications
//       const medsRes = await fetch("https://dairy.server.statify.co.ke/api/medications");
//       const medsData = await medsRes.json();
//       if (Array.isArray(medsData)) {
//         setMedications(medsData);
//       }
//     } catch (err) {
//       console.error('Error fetching data:', err);
//     }
//   };

//   // Fetch Usage Statistics
//   const fetchUsageStats = async () => {
//     try {
//       const res = await fetch(`${API_URL}/statistics`);
//       const data = await res.json();
//       setUsageStats(data);
//     } catch (err) {
//       console.error('Error fetching usage statistics:', err);
//     }
//   };

//   useEffect(() => {
//     fetchUsageRecords();
//     fetchAnimalsAndMeds();
//     fetchUsageStats();
//   }, []);

//   // Filter records based on search and filters
//   useEffect(() => {
//     if (!Array.isArray(usageRecords)) {
//       setFilteredRecords([]);
//       return;
//     }
    
//     let results = usageRecords;

//     // Apply search term
//     if (searchTerm) {
//       results = results.filter(record =>
//         (record.medication_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (record.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (record.notes?.toLowerCase() || '').includes(searchTerm.toLowerCase())
//       );
//     }

//     // Apply animal filter
//     if (filters.animal_id) {
//       results = results.filter(record => 
//         record.animal_id.toString() === filters.animal_id
//       );
//     }

//     // Apply medication filter
//     if (filters.medication_id) {
//       results = results.filter(record => 
//         record.medication_id.toString() === filters.medication_id
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
        
//         if (aVal === null || aVal === undefined) return 1;
//         if (bVal === null || bVal === undefined) return -1;
        
//         if (sortConfig.key === 'date') {
//           try {
//             const aDate = new Date(a.originalDate || a.date);
//             const bDate = new Date(b.originalDate || b.date);
            
//             if (isNaN(aDate.getTime()) || isNaN(bDate.getTime())) return 0;
            
//             return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
//           } catch (err) {
//             return 0;
//           }
//         }
        
//         if (typeof aVal === 'string' && typeof bVal === 'string') {
//           return sortConfig.direction === 'asc' 
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }
        
//         if (aVal < bVal) {
//           return sortConfig.direction === 'asc' ? -1 : 1;
//         }
//         if (aVal > bVal) {
//           return sortConfig.direction === 'asc' ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     setFilteredRecords(results);
//   }, [usageRecords, searchTerm, filters, sortConfig]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       animal_id: "",
//       medication_id: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   };

//   // Form Handlers
//   const handleFormChange = (field, value) => {
//     setUsageForm(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const resetForm = () => {
//     setUsageForm({
//       medication_id: "",
//       animal_id: "",
//       quantity_used: "",
//       date: new Date().toISOString().split('T')[0],
//       notes: ""
//     });
//   };

//   // Get available quantity for selected medication
//   const getAvailableQuantity = () => {
//     const medication = medications.find(med => med.id.toString() === usageForm.medication_id);
//     return medication ? medication.quantity : 0;
//   };

//   // Create Usage Record
//   const handleCreateUsageRecord = async () => {
//     if (!usageForm.medication_id || !usageForm.animal_id || !usageForm.quantity_used) {
//       swal("Error", "Medication, animal, and quantity used are required", "error");
//       return;
//     }

//     if (usageForm.quantity_used <= 0) {
//       swal("Error", "Quantity used must be positive", "error");
//       return;
//     }

//     const availableQty = getAvailableQuantity();
//     if (usageForm.quantity_used > availableQty) {
//       swal("Error", `Insufficient medication quantity. Available: ${availableQty}`, "error");
//       return;
//     }

//     try {
//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...usageForm,
//           medication_id: parseInt(usageForm.medication_id),
//           animal_id: parseInt(usageForm.animal_id),
//           quantity_used: parseFloat(usageForm.quantity_used)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Medication usage recorded successfully!", "success");
//         setOpenCreateDialog(false);
//         resetForm();
//         fetchUsageRecords();
//         fetchUsageStats();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Update Usage Record
//   const handleUpdateUsageRecord = async () => {
//     if (!selectedRecord) return;

//     try {
//       const res = await fetch(`${API_URL}/${selectedRecord.id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...usageForm,
//           medication_id: parseInt(usageForm.medication_id),
//           animal_id: parseInt(usageForm.animal_id),
//           quantity_used: parseFloat(usageForm.quantity_used)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Usage record updated successfully!", "success");
//         setOpenEditDialog(false);
//         setSelectedRecord(null);
//         resetForm();
//         fetchUsageRecords();
//         fetchUsageStats();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (recordId) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the usage record!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${recordId}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           fetchUsageRecords();
//           fetchUsageStats();
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // View Handler
//   const handleView = (record) => {
//     setSelectedRecord(record);
//     setOpenViewDialog(true);
//   };

//   // Open Edit Dialog - FIXED VERSION
//   const handleEdit = (record) => {
//     setSelectedRecord(record);
    
//     // Use the helper function to safely format the date
//     const formattedDate = formatDateForInput(record.originalDate || record.date);
    
//     setUsageForm({
//       medication_id: record.medication_id.toString(),
//       animal_id: record.animal_id.toString(),
//       quantity_used: record.quantity_used.toString(),
//       date: formattedDate,
//       notes: record.notes || ""
//     });
//     setOpenEditDialog(true);
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: 'info.main', 
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           <TableSortLabel
//             active={sortConfig.key === column.dataKey}
//             direction={sortConfig.direction}
//             onClick={() => handleSort(column.dataKey)}
//             sx={{ color: 'white !important' }}
//           >
//             {column.label}
//           </TableSortLabel>
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, record) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {record.medication_name}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {record.animal_id}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {record.animal_name}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {record.quantity_used} units
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {record.date}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap title={record.notes}>
//           {record.short_notes}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             color="info"
//             onClick={() => handleView(record)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="primary"
//             onClick={() => handleEdit(record)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(record.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'info.dark' }}>
//         <Toolbar>
//           <UsageIcon sx={{ mr: 2 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Medication Usage
//           </Typography>
//           <Button 
//             startIcon={<StatsIcon />}
//             onClick={() => setOpenStatsDialog(true)}
//             variant="outlined"
//             sx={{ color: 'white', borderColor: 'white', mr: 2 }}
//           >
//             Statistics
//           </Button>
//           <Chip 
//             label={`${usageRecords.length} Records`} 
//             color="primary" 
//             variant="filled"
//             sx={{ color: 'white', fontWeight: 'bold', mr: 2 }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={() => setOpenCreateDialog(true)}
//             sx={{ borderRadius: 2, backgroundColor: 'success.main' }}
//           >
//             Record Usage
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: 'info.light' }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search by medication, animal name, or notes..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     color="info"
//                   >
//                     Filters
//                   </Button>
//                   <Button onClick={resetFilters} variant="outlined" size="small" color="info">
//                     Reset
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth 
//                                          sx={{
//                                               minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}>
//                       <InputLabel>Animal</InputLabel>
//                       <Select
//                         value={filters.animal_id}
//                         onChange={(e) => handleFilterChange('animal_id', e.target.value)}
//                         label="Animal"
//                       >
//                         <MenuItem value="">All Animals</MenuItem>
//                         {animals.map(animal => (
//                           <MenuItem key={animal.id} value={animal.id.toString()}>
//                             {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth 
//                      sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}
                    
//                     >
//                       <InputLabel>Medication</InputLabel>
//                       <Select
//                         value={filters.medication_id}
//                         onChange={(e) => handleFilterChange('medication_id', e.target.value)}
//                         label="Medication"
//                       >
//                         <MenuItem value="">All Medications</MenuItem>
//                         {medications.map(med => (
//                           <MenuItem key={med.id} value={med.id.toString()}>
//                             {med.name} ({med.quantity} available)
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
                       
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress color="info" />
//               </Box>
//             ) : filteredRecords.length === 0 ? (
//               <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: 'info.light' }}>
//                 <CardContent>
//                   <AnimalIcon sx={{ fontSize: 64, color: 'info.main', mb: 2 }} />
//                   <Typography variant="h5" color="info.main" gutterBottom>
//                     No usage records found
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     Start tracking medication usage by recording administration to animals
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     color="info" 
//                     onClick={() => setOpenCreateDialog(true)} 
//                     size="large"
//                   >
//                     Record First Usage
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: 'info.light', borderRadius: 1 }}>
//                 <TableVirtuoso
//                   data={filteredRecords}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Create Usage Record Dialog */}
//       <Dialog 
//         open={openCreateDialog} 
//         onClose={() => setOpenCreateDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <AddIcon sx={{ mr: 1 }} />
//             Record Medication Usage
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth
              
//                sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}>
//                 <InputLabel>Medication *</InputLabel>
//                 <Select
//                   value={usageForm.medication_id}
//                   onChange={(e) => handleFormChange('medication_id', e.target.value)}
//                   label="Medication *"
//                 >
//                   {medications.map(med => (
//                     <MenuItem key={med.id} value={med.id.toString()}>
//                       {med.name} ({med.quantity} available)
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth
              
//                sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}>
//                 <InputLabel>Animal *</InputLabel>
//                 <Select
//                   value={usageForm.animal_id}
//                   onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                   label="Animal *"
//                 >
//                   {animals.map(animal => (
//                     <MenuItem key={animal.id} value={animal.id.toString()}>
//                       {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Quantity Used *"
//                 type="number"
//                 value={usageForm.quantity_used}
//                 onChange={(e) => handleFormChange('quantity_used', e.target.value)}
//                 inputProps={{ min: 0.1, step: 0.1 }}
//                 helperText={
//                   usageForm.medication_id ? 
//                   `Available: ${getAvailableQuantity()} units` : 
//                   'Select a medication first'
//                 }
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Usage Date"
//                 type="date"
//                 value={usageForm.date}
//                 onChange={(e) => handleFormChange('date', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Notes"
//                 placeholder="Enter administration notes, dosage instructions, or observations..."
//                 value={usageForm.notes}
//                 onChange={(e) => handleFormChange('notes', e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenCreateDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleCreateUsageRecord} 
//             variant="contained" 
//             color="success"
//             disabled={!usageForm.medication_id || !usageForm.animal_id || !usageForm.quantity_used}
//           >
//             Record Usage
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Usage Record Dialog */}
//       <Dialog 
//         open={openEditDialog} 
//         onClose={() => setOpenEditDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <EditIcon sx={{ mr: 1 }} />
//             Edit Usage Record
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Medication *</InputLabel>
//                 <Select
//                   value={usageForm.medication_id}
//                   onChange={(e) => handleFormChange('medication_id', e.target.value)}
//                   label="Medication *"
//                 >
//                   {medications.map(med => (
//                     <MenuItem key={med.id} value={med.id.toString()}>
//                       {med.name} ({med.quantity} available)
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Animal *</InputLabel>
//                 <Select
//                   value={usageForm.animal_id}
//                   onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                   label="Animal *"
//                 >
//                   {animals.map(animal => (
//                     <MenuItem key={animal.id} value={animal.id.toString()}>
//                       {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Quantity Used *"
//                 type="number"
//                 value={usageForm.quantity_used}
//                 onChange={(e) => handleFormChange('quantity_used', e.target.value)}
//                 inputProps={{ min: 0.1, step: 0.1 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Usage Date"
//                 type="date"
//                 value={usageForm.date}
//                 onChange={(e) => handleFormChange('date', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Notes"
//                 value={usageForm.notes}
//                 onChange={(e) => handleFormChange('notes', e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleUpdateUsageRecord} 
//             variant="contained" 
//             color="primary"
//             disabled={!usageForm.medication_id || !usageForm.animal_id || !usageForm.quantity_used}
//           >
//             Update Record
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* View Usage Record Dialog */}
//       <Dialog 
//         open={openViewDialog} 
//         onClose={() => setOpenViewDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <ViewIcon sx={{ mr: 1 }} />
//               Usage Record Details
//             </Box>
//             <IconButton onClick={() => setOpenViewDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedRecord && (
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Medication Information
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Medication:</strong> {selectedRecord.medication_name}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Quantity Used:</strong> {selectedRecord.quantity_used} units
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
              
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Animal Information
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Animal ID:</strong> {selectedRecord.animal_id}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Animal Name:</strong> {selectedRecord.animal_name}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Usage Details
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Date:</strong> {selectedRecord.date}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {selectedRecord.notes && (
//                 <Grid item xs={12}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <Typography variant="h6" gutterBottom color="primary">
//                         Administration Notes
//                       </Typography>
//                       <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
//                         {selectedRecord.notes}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               )}
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Statistics Dialog */}
//       <Dialog 
//         open={openStatsDialog} 
//         onClose={() => setOpenStatsDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <StatsIcon sx={{ mr: 1 }} />
//               Medication Usage Statistics
//             </Box>
//             <IconButton onClick={() => setOpenStatsDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {usageStats ? (
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Overview
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Total Records:</strong> {usageStats.total_records}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Total Quantity Used:</strong> {usageStats.total_quantity_used} units
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Medication Breakdown
//                     </Typography>
//                     {Object.entries(usageStats.medication_breakdown).length > 0 ? (
//                       Object.entries(usageStats.medication_breakdown).map(([medName, quantity]) => (
//                         <Box key={medName} sx={{ 
//                           display: 'flex', 
//                           justifyContent: 'space-between', 
//                           alignItems: 'center',
//                           py: 1,
//                           borderBottom: '1px solid',
//                           borderColor: 'divider'
//                         }}>
//                           <Typography variant="body2">{medName}</Typography>
//                           <Chip 
//                             label={`${quantity} units`} 
//                             size="small"
//                             color="primary"
//                           />
//                         </Box>
//                       ))
//                     ) : (
//                       <Typography variant="body2" color="textSecondary">
//                         No usage data available
//                       </Typography>
//                     )}
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {usageStats.period && (usageStats.period.start_date || usageStats.period.end_date) && (
//                 <Grid item xs={12}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <Typography variant="h6" gutterBottom color="primary">
//                         Period
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Start Date:</strong> {usageStats.period.start_date ? 
//                           new Date(usageStats.period.start_date).toLocaleDateString() : 'Not specified'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>End Date:</strong> {usageStats.period.end_date ? 
//                           new Date(usageStats.period.end_date).toLocaleDateString() : 'Not specified'}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               )}
//             </Grid>
//           ) : (
//             <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//               <CircularProgress color="info" />
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenStatsDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Add FAB for mobile */}
//       <Fab
//         color="info"
//         aria-label="add"
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' }
//         }}
//         onClick={() => setOpenCreateDialog(true)}
//       >
//         <AddIcon />
//       </Fab>
//     </Box>
//   );
// };

// export default MedicationUsagePage;




import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Close as CloseIcon,
  MedicalServices as UsageIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
  TrendingUp as StatsIcon,
  Pets as AnimalIcon,
} from "@mui/icons-material";
import { TableVirtuoso } from "react-virtuoso";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Color constants
const PRIMARY_COLOR = '#024A59';
const SECONDARY_COLOR = '#FFA916';
const PRIMARY_LIGHT = '#346875';
const PRIMARY_DARK = '#013440';

// Virtualized Table Components
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow: (props) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

const MedicationUsagePage = () => {
  const navigate = useNavigate();
  const [usageRecords, setUsageRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Filters and Search
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filters, setFilters] = useState({
    animal_id: "",
    medication_id: ""
  });

  // Dialogs
  const [showFilters, setShowFilters] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openStatsDialog, setOpenStatsDialog] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  // Form Data
  const [usageForm, setUsageForm] = useState({
    medication_id: "",
    animal_id: "",
    quantity_used: "",
    date: new Date().toISOString().split('T')[0],
    notes: ""
  });

  const [animals, setAnimals] = useState([]);
  const [medications, setMedications] = useState([]);
  const [usageStats, setUsageStats] = useState(null);

  const API_URL = "https://dairy.server.statify.co.ke/api/medication-usage";

  // Helper function to format date for form input
  const formatDateForInput = (dateString) => {
    if (!dateString) return new Date().toISOString().split('T')[0];
    
    try {
      // Try parsing the date string - handle various formats
      const date = new Date(dateString);
      
      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.warn('Invalid date:', dateString);
        return new Date().toISOString().split('T')[0];
      }
      
      return date.toISOString().split('T')[0];
    } catch (error) {
      console.error('Error formatting date:', error, dateString);
      return new Date().toISOString().split('T')[0];
    }
  };

  // Table Columns for Virtualized Table
  const columns = [
    { width: 150, label: 'Medication', dataKey: 'medication_name' },
    { width: 120, label: 'Animal ID', dataKey: 'animal_id' },
    { width: 150, label: 'Animal Name', dataKey: 'animal_name' },
    { width: 120, label: 'Quantity Used', dataKey: 'quantity_used' },
    { width: 120, label: 'Usage Date', dataKey: 'date' },
    { width: 200, label: 'Notes', dataKey: 'notes' },
    { width: 200, label: 'Actions', dataKey: 'actions' },
  ];

  // Fetch Usage Records
  const fetchUsageRecords = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      
      if (Array.isArray(data)) {
        // Transform data to include formatted dates
        const transformedRecords = data.map(record => {
          // Format date for display
          let displayDate = "Invalid Date";
          try {
            const recordDate = new Date(record.date);
            if (!isNaN(recordDate.getTime())) {
              displayDate = recordDate.toLocaleDateString();
            }
          } catch (err) {
            console.error('Error formatting date:', err);
          }

          return {
            ...record,
            date: displayDate,
            short_notes: record.notes ? 
              (record.notes.length > 30 ? `${record.notes.substring(0, 30)}...` : record.notes) 
              : 'No notes',
            originalDate: record.date // Keep original date for editing
          };
        });
        setUsageRecords(transformedRecords);
      } else {
        setUsageRecords([]);
      }
    } catch (err) {
      console.error('Error fetching usage records:', err);
      swal("Error", "Failed to fetch medication usage records", "error");
      setUsageRecords([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Animals and Medications
  const fetchAnimalsAndMeds = async () => {
    try {
      // Fetch animals
      const animalsRes = await fetch("https://dairy.server.statify.co.ke/api/animals");
      const animalsData = await animalsRes.json();
      if (animalsData.animals && Array.isArray(animalsData.animals)) {
        setAnimals(animalsData.animals);
      } else if (Array.isArray(animalsData)) {
        setAnimals(animalsData);
      }

      // Fetch medications
      const medsRes = await fetch("https://dairy.server.statify.co.ke/api/medications");
      const medsData = await medsRes.json();
      if (Array.isArray(medsData)) {
        setMedications(medsData);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  // Fetch Usage Statistics
  const fetchUsageStats = async () => {
    try {
      const res = await fetch(`${API_URL}/statistics`);
      const data = await res.json();
      setUsageStats(data);
    } catch (err) {
      console.error('Error fetching usage statistics:', err);
    }
  };

  useEffect(() => {
    fetchUsageRecords();
    fetchAnimalsAndMeds();
    fetchUsageStats();
  }, []);

  // Filter records based on search and filters
  useEffect(() => {
    if (!Array.isArray(usageRecords)) {
      setFilteredRecords([]);
      return;
    }
    
    let results = usageRecords;

    // Apply search term
    if (searchTerm) {
      results = results.filter(record =>
        (record.medication_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (record.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (record.notes?.toLowerCase() || '').includes(searchTerm.toLowerCase())
      );
    }

    // Apply animal filter
    if (filters.animal_id) {
      results = results.filter(record => 
        record.animal_id.toString() === filters.animal_id
      );
    }

    // Apply medication filter
    if (filters.medication_id) {
      results = results.filter(record => 
        record.medication_id.toString() === filters.medication_id
      );
    }

    // Apply sorting
    if (sortConfig.key) {
      results.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        if (sortConfig.key === 'date') {
          try {
            const aDate = new Date(a.originalDate || a.date);
            const bDate = new Date(b.originalDate || b.date);
            
            if (isNaN(aDate.getTime()) || isNaN(bDate.getTime())) return 0;
            
            return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
          } catch (err) {
            return 0;
          }
        }
        
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return sortConfig.direction === 'asc' 
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
        
        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredRecords(results);
  }, [usageRecords, searchTerm, filters, sortConfig]);

  // Sort Handler
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filter Handlers
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      animal_id: "",
      medication_id: ""
    });
    setSearchTerm("");
    setSortConfig({ key: null, direction: 'asc' });
  };

  // Form Handlers
  const handleFormChange = (field, value) => {
    setUsageForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setUsageForm({
      medication_id: "",
      animal_id: "",
      quantity_used: "",
      date: new Date().toISOString().split('T')[0],
      notes: ""
    });
  };

  // Get available quantity for selected medication
  const getAvailableQuantity = () => {
    const medication = medications.find(med => med.id.toString() === usageForm.medication_id);
    return medication ? medication.quantity : 0;
  };

  // Create Usage Record
  const handleCreateUsageRecord = async () => {
    if (!usageForm.medication_id || !usageForm.animal_id || !usageForm.quantity_used) {
      swal("Error", "Medication, animal, and quantity used are required", "error");
      return;
    }

    if (usageForm.quantity_used <= 0) {
      swal("Error", "Quantity used must be positive", "error");
      return;
    }

    const availableQty = getAvailableQuantity();
    if (usageForm.quantity_used > availableQty) {
      swal("Error", `Insufficient medication quantity. Available: ${availableQty}`, "error");
      return;
    }

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...usageForm,
          medication_id: parseInt(usageForm.medication_id),
          animal_id: parseInt(usageForm.animal_id),
          quantity_used: parseFloat(usageForm.quantity_used)
        }),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Medication usage recorded successfully!", "success");
        setOpenCreateDialog(false);
        resetForm();
        fetchUsageRecords();
        fetchUsageStats();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Update Usage Record
  const handleUpdateUsageRecord = async () => {
    if (!selectedRecord) return;

    try {
      const res = await fetch(`${API_URL}/${selectedRecord.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...usageForm,
          medication_id: parseInt(usageForm.medication_id),
          animal_id: parseInt(usageForm.animal_id),
          quantity_used: parseFloat(usageForm.quantity_used)
        }),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Usage record updated successfully!", "success");
        setOpenEditDialog(false);
        setSelectedRecord(null);
        resetForm();
        fetchUsageRecords();
        fetchUsageStats();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Delete Handler
  const handleDelete = async (recordId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the usage record!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${recordId}`, { method: "DELETE" });
        const data = await res.json();
        if (res.ok) {
          swal("Deleted!", data.message, "success");
          fetchUsageRecords();
          fetchUsageStats();
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // View Handler
  const handleView = (record) => {
    setSelectedRecord(record);
    setOpenViewDialog(true);
  };

  // Open Edit Dialog - FIXED VERSION
  const handleEdit = (record) => {
    setSelectedRecord(record);
    
    // Use the helper function to safely format the date
    const formattedDate = formatDateForInput(record.originalDate || record.date);
    
    setUsageForm({
      medication_id: record.medication_id.toString(),
      animal_id: record.animal_id.toString(),
      quantity_used: record.quantity_used.toString(),
      date: formattedDate,
      notes: record.notes || ""
    });
    setOpenEditDialog(true);
  };

  // Virtualized Table Content
  const fixedHeaderContent = () => (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="left"
          style={{ width: column.width }}
          sx={{ 
            backgroundColor: PRIMARY_COLOR, 
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '12px 8px'
          }}
        >
          <TableSortLabel
            active={sortConfig.key === column.dataKey}
            direction={sortConfig.direction}
            onClick={() => handleSort(column.dataKey)}
            sx={{ color: 'white !important' }}
          >
            {column.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  );

  const rowContent = (index, record) => (
    <React.Fragment>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {record.medication_name}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {record.animal_id}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {record.animal_name}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" sx={{ color: PRIMARY_COLOR }} noWrap>
          {record.quantity_used} units
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {record.date}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap title={record.notes}>
          {record.short_notes}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
          <IconButton 
            size="small" 
            onClick={() => handleView(record)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: PRIMARY_COLOR
            }}
          >
            <ViewIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleEdit(record)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: PRIMARY_LIGHT
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleDelete(record.id)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: '#d32f2f'
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </React.Fragment>
  );

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: PRIMARY_COLOR }}>
        <Toolbar>
          <UsageIcon sx={{ mr: 2 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Medication Usage
          </Typography>
          <Button 
            startIcon={<StatsIcon />}
            onClick={() => setOpenStatsDialog(true)}
            variant="outlined"
            sx={{ 
              color: 'white', 
              borderColor: 'white', 
              mr: 2,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderColor: 'white'
              }
            }}
          >
            Statistics
          </Button>
          <Chip 
            label={`${usageRecords.length} Records`} 
            sx={{ 
              backgroundColor: SECONDARY_COLOR, 
              color: 'white', 
              fontWeight: 'bold', 
              mr: 2 
            }}
          />
          <Button 
            variant="contained" 
            startIcon={<AddIcon />}
            onClick={() => setOpenCreateDialog(true)}
            sx={{ 
              borderRadius: 2, 
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
            Record Usage
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: PRIMARY_LIGHT }}>
          {/* Search and Filters */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Search by medication, animal name, or notes..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<FilterIcon />}
                    onClick={() => setShowFilters(!showFilters)}
                    variant={showFilters ? "contained" : "outlined"}
                    size="small"
                    sx={{
                      backgroundColor: showFilters ? PRIMARY_COLOR : 'transparent',
                      color: showFilters ? 'white' : PRIMARY_COLOR,
                      borderColor: PRIMARY_COLOR,
                      '&:hover': {
                        backgroundColor: showFilters ? PRIMARY_DARK : 'rgba(2, 74, 89, 0.04)',
                        borderColor: PRIMARY_DARK,
                      }
                    }}
                  >
                    Filters
                  </Button>
                  <Button 
                    onClick={resetFilters} 
                    variant="outlined" 
                    size="small" 
                    sx={{
                      color: PRIMARY_COLOR,
                      borderColor: PRIMARY_COLOR,
                      '&:hover': {
                        borderColor: PRIMARY_DARK,
                        backgroundColor: 'rgba(2, 74, 89, 0.04)',
                      }
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Expandable Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth sx={{ minWidth: { xs: '100%', sm: 250, md: 300 } }}>
                      <InputLabel>Animal</InputLabel>
                      <Select
                        value={filters.animal_id}
                        onChange={(e) => handleFilterChange('animal_id', e.target.value)}
                        label="Animal"
                      >
                        <MenuItem value="">All Animals</MenuItem>
                        {animals.map(animal => (
                          <MenuItem key={animal.id} value={animal.id.toString()}>
                            {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth sx={{ minWidth: { xs: '100%', sm: 250, md: 300 } }}>
                      <InputLabel>Medication</InputLabel>
                      <Select
                        value={filters.medication_id}
                        onChange={(e) => handleFilterChange('medication_id', e.target.value)}
                        label="Medication"
                      >
                        <MenuItem value="">All Medications</MenuItem>
                        {medications.map(med => (
                          <MenuItem key={med.id} value={med.id.toString()}>
                            {med.name} ({med.quantity} available)
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Content Area */}
          <Box sx={{ p: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress sx={{ color: PRIMARY_COLOR }} />
              </Box>
            ) : filteredRecords.length === 0 ? (
              <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: PRIMARY_LIGHT }}>
                <CardContent>
                  <AnimalIcon sx={{ fontSize: 64, color: PRIMARY_COLOR, mb: 2 }} />
                  <Typography variant="h5" sx={{ color: PRIMARY_COLOR }} gutterBottom>
                    No usage records found
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    Start tracking medication usage by recording administration to animals
                  </Typography>
                  <Button 
                    variant="contained" 
                    onClick={() => setOpenCreateDialog(true)} 
                    size="large"
                    sx={{
                      backgroundColor: SECONDARY_COLOR,
                      '&:hover': {
                        backgroundColor: '#e59400'
                      }
                    }}
                  >
                    Record First Usage
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: PRIMARY_LIGHT, borderRadius: 1 }}>
                <TableVirtuoso
                  data={filteredRecords}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </Paper>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Create Usage Record Dialog */}
      <Dialog 
        open={openCreateDialog} 
        onClose={() => setOpenCreateDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: PRIMARY_COLOR, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <AddIcon sx={{ mr: 1 }} />
            Record Medication Usage
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth sx={{ minWidth: { xs: '100%', sm: 250, md: 300 } }}>
                <InputLabel>Medication *</InputLabel>
                <Select
                  value={usageForm.medication_id}
                  onChange={(e) => handleFormChange('medication_id', e.target.value)}
                  label="Medication *"
                >
                  {medications.map(med => (
                    <MenuItem key={med.id} value={med.id.toString()}>
                      {med.name} ({med.quantity} available)
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth sx={{ minWidth: { xs: '100%', sm: 250, md: 300 } }}>
                <InputLabel>Animal *</InputLabel>
                <Select
                  value={usageForm.animal_id}
                  onChange={(e) => handleFormChange('animal_id', e.target.value)}
                  label="Animal *"
                >
                  {animals.map(animal => (
                    <MenuItem key={animal.id} value={animal.id.toString()}>
                      {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Quantity Used *"
                type="number"
                value={usageForm.quantity_used}
                onChange={(e) => handleFormChange('quantity_used', e.target.value)}
                inputProps={{ min: 0.1, step: 0.1 }}
                helperText={
                  usageForm.medication_id ? 
                  `Available: ${getAvailableQuantity()} units` : 
                  'Select a medication first'
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Usage Date"
                type="date"
                value={usageForm.date}
                onChange={(e) => handleFormChange('date', e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Notes"
                placeholder="Enter administration notes, dosage instructions, or observations..."
                value={usageForm.notes}
                onChange={(e) => handleFormChange('notes', e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCreateDialog(false)}>Cancel</Button>
          <Button 
            onClick={handleCreateUsageRecord} 
            variant="contained" 
            disabled={!usageForm.medication_id || !usageForm.animal_id || !usageForm.quantity_used}
            sx={{
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
            Record Usage
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Usage Record Dialog */}
      <Dialog 
        open={openEditDialog} 
        onClose={() => setOpenEditDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: PRIMARY_COLOR, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <EditIcon sx={{ mr: 1 }} />
            Edit Usage Record
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Medication *</InputLabel>
                <Select
                  value={usageForm.medication_id}
                  onChange={(e) => handleFormChange('medication_id', e.target.value)}
                  label="Medication *"
                >
                  {medications.map(med => (
                    <MenuItem key={med.id} value={med.id.toString()}>
                      {med.name} ({med.quantity} available)
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Animal *</InputLabel>
                <Select
                  value={usageForm.animal_id}
                  onChange={(e) => handleFormChange('animal_id', e.target.value)}
                  label="Animal *"
                >
                  {animals.map(animal => (
                    <MenuItem key={animal.id} value={animal.id.toString()}>
                      {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Quantity Used *"
                type="number"
                value={usageForm.quantity_used}
                onChange={(e) => handleFormChange('quantity_used', e.target.value)}
                inputProps={{ min: 0.1, step: 0.1 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Usage Date"
                type="date"
                value={usageForm.date}
                onChange={(e) => handleFormChange('date', e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Notes"
                value={usageForm.notes}
                onChange={(e) => handleFormChange('notes', e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
          <Button 
            onClick={handleUpdateUsageRecord} 
            variant="contained" 
            disabled={!usageForm.medication_id || !usageForm.animal_id || !usageForm.quantity_used}
            sx={{
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
            Update Record
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Usage Record Dialog */}
      <Dialog 
        open={openViewDialog} 
        onClose={() => setOpenViewDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ViewIcon sx={{ mr: 1 }} />
              Usage Record Details
            </Box>
            <IconButton onClick={() => setOpenViewDialog(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedRecord && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Medication Information
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Medication:</strong> {selectedRecord.medication_name}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Quantity Used:</strong> {selectedRecord.quantity_used} units
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Animal Information
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Animal ID:</strong> {selectedRecord.animal_id}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Animal Name:</strong> {selectedRecord.animal_name}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Usage Details
                    </Typography>
                    <Typography variant="body2">
                      <strong>Date:</strong> {selectedRecord.date}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              {selectedRecord.notes && (
                <Grid item xs={12}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                        Administration Notes
                      </Typography>
                      <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                        {selectedRecord.notes}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Statistics Dialog */}
      <Dialog 
        open={openStatsDialog} 
        onClose={() => setOpenStatsDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: PRIMARY_COLOR, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <StatsIcon sx={{ mr: 1 }} />
              Medication Usage Statistics
            </Box>
            <IconButton onClick={() => setOpenStatsDialog(false)} sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {usageStats ? (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Overview
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Total Records:</strong> {usageStats.total_records}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Total Quantity Used:</strong> {usageStats.total_quantity_used} units
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Medication Breakdown
                    </Typography>
                    {Object.entries(usageStats.medication_breakdown).length > 0 ? (
                      Object.entries(usageStats.medication_breakdown).map(([medName, quantity]) => (
                        <Box key={medName} sx={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'center',
                          py: 1,
                          borderBottom: '1px solid',
                          borderColor: 'divider'
                        }}>
                          <Typography variant="body2">{medName}</Typography>
                          <Chip 
                            label={`${quantity} units`} 
                            size="small"
                            sx={{
                              backgroundColor: SECONDARY_COLOR,
                              color: 'white'
                            }}
                          />
                        </Box>
                      ))
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        No usage data available
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              {usageStats.period && (usageStats.period.start_date || usageStats.period.end_date) && (
                <Grid item xs={12}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                        Period
                      </Typography>
                      <Typography variant="body2">
                        <strong>Start Date:</strong> {usageStats.period.start_date ? 
                          new Date(usageStats.period.start_date).toLocaleDateString() : 'Not specified'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>End Date:</strong> {usageStats.period.end_date ? 
                          new Date(usageStats.period.end_date).toLocaleDateString() : 'Not specified'}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
              <CircularProgress sx={{ color: PRIMARY_COLOR }} />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenStatsDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Add FAB for mobile */}
      <Fab
        aria-label="add"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'flex', md: 'none' },
          backgroundColor: PRIMARY_COLOR,
          '&:hover': {
            backgroundColor: PRIMARY_DARK
          }
        }}
        onClick={() => setOpenCreateDialog(true)}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default MedicationUsagePage;